
export default {
  // Navigation
  'nav.home': 'Nyumbani',
  'nav.about': 'Kuhusu',
  'nav.contact': 'Wasiliana',
  'nav.login': 'Ingia',
  'nav.register': 'Jisajili',
  'nav.dashboard': 'Dashibodi',
  'nav.investments': 'Uwekezaji',
  
  // Hero Section
  'hero.title': 'Pata Mikopo Hadi Mara 20 ya Thamani ya Hisa Zako',
  'hero.subtitle': 'Nunua hisa kati ya TSh 20,000 - TSh 500,000 na upate mikopo hadi mara 20 ya thamani ya hisa zako. Ongezeko la mapato la 100% kwa uwekezaji wako.',
  'hero.cta': 'Anza Sasa',
  
  // Features
  'features.title': 'Kwa Nini Utuchague',
  'features.loans.title': 'Mikopo ya Haraka',
  'features.loans.desc': 'Pata mikopo hadi mara 20 ya thamani ya hisa zako',
  'features.returns.title': 'Mapato ya Juu',
  'features.returns.desc': 'Pata mapato ya 100% kwa uwekezaji wako',
  'features.secure.title': 'Salama 100%',
  'features.secure.desc': 'Kampuni iliyosajiliwa na kudhibitishwa',
  
  // How It Works
  'howItWorks.title': 'Jinsi Inavyofanya Kazi',
  'howItWorks.step1.title': 'Jisajili',
  'howItWorks.step1.desc': 'Fungua akaunti yako bila malipo',
  'howItWorks.step2.title': 'Nunua Hisa',
  'howItWorks.step2.desc': 'Nunua hisa kati ya TSh 20,000 - TSh 500,000',
  'howItWorks.step3.title': 'Pata Mkopo',
  'howItWorks.step3.desc': 'Omba mkopo hadi mara 20 ya hisa zako',
  'howItWorks.step4.title': 'Pata Mapato',
  'howItWorks.step4.desc': 'Pata mapato ya 100% kwa uwekezaji wako',
  
  // Dashboard
  'dashboard.welcome': 'Karibu',
  'dashboard.overview': 'Muhtasari wa Akaunti',
  'dashboard.shares': 'Hisa Zilizopatikana',
  'dashboard.loanBalance': 'Salio la Mkopo',
  'dashboard.availableLoan': 'Mkopo Unapatikana',
  'dashboard.totalReturns': 'Jumla ya Mapato',
  'dashboard.purchaseShares': 'Nunua Hisa',
  'dashboard.applyLoan': 'Omba Mkopo',
  'dashboard.viewInvestments': 'Tazama Uwekezaji',
  
  // Forms
  'form.email': 'Barua Pepe',
  'form.password': 'Nywila',
  'form.confirmPassword': 'Thibitisha Nywila',
  'form.fullName': 'Jina Kamili',
  'form.phone': 'Nambari ya Simu',
  'form.country': 'Nchi',
  'form.submit': 'Wasilisha',
  'form.cancel': 'Ghairi',
  
  // Buttons
  'btn.getStarted': 'Anza Sasa',
  'btn.learnMore': 'Jifunze Zaidi',
  'btn.contactUs': 'Wasiliana Nasi',
  'btn.buyNow': 'Nunua Sasa',
  'btn.apply': 'Omba',
  
  // Support
  'support.title': 'Msaada wa Telegram',
  'support.desc': 'Wasiliana nasi kupitia Telegram kwa msaada wa haraka',
  'support.available': 'Inapatikana Saa 24/7',
  
  // Footer
  'footer.rights': 'Haki zote zimehifadhiwa',
  'footer.company': 'Kampuni',
  'footer.support': 'Msaada',
  'footer.legal': 'Kisheria'
};
